
import { defineComponent } from "vue";

export default defineComponent({
  inject: [
    "numColumns",
  ],
  props: {
    span: { type: Number, default: 1 },
  },
});
